export default __webpack_public_path__ + "static/media/banner2.ff22c171.jpg";